(function() {
  'use strict';

  function showBtnError(btn, msg) {
    var snapshot = [];
    while (btn.firstChild) {
      snapshot.push(btn.removeChild(btn.firstChild));
    }
    btn.classList.add('lp-atc-btn--error');
    btn.textContent = msg || 'Erro — tente novamente';
    setTimeout(function() {
      btn.classList.remove('lp-atc-btn--error');
      btn.textContent = '';
      snapshot.forEach(function(node) { btn.appendChild(node); });
    }, 3000);
  }

  function isSoldOutError(err) {
    var message = [
      err && err.description,
      err && err.message,
      err && err.status,
      err && err.name
    ].join(' ').toLowerCase();

    return message.indexOf('esgot') !== -1 ||
      message.indexOf('sold out') !== -1 ||
      message.indexOf('out of stock') !== -1;
  }

  function isRestockButton(btn) {
    var label = (btn.textContent || '').toLowerCase();

    return btn.matches('.stoq-notify-me, .stq-trigger, .BIS_trigger, [data-restock-notify]') ||
      (btn.dataset.variantId && (
        label.indexOf('avise') !== -1 ||
        label.indexOf('avisado') !== -1 ||
        label.indexOf('estoque voltar') !== -1
      ));
  }

  function refreshCartDrawer() {
    if (typeof Shopify !== 'undefined' && Shopify.getCart) {
      Shopify.getCart(function(cart) {
        if (window.updateCart) window.updateCart(cart);
        document.body.classList.add('cart-sidebar-show');
      });
    } else {
      document.body.classList.add('cart-sidebar-show');
    }
  }

  function getButtonQuantity(btn) {
    var quantity = parseInt(btn.dataset.quantity, 10);
    var form = btn.closest('form');
    var quantityInput = form ? form.querySelector('[name="quantity"]') : null;

    if (quantityInput) {
      quantity = parseInt(quantityInput.value, 10);
    }

    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function lpAddToCart(variantId, btn) {
    if (!variantId) return;
    var quantity = getButtonQuantity(btn);
    btn.classList.add('lp-atc-btn--loading');
    btn.disabled = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity }] })
    })
    .then(function(r) { return r.ok ? r.json() : r.json().then(function(e) { throw e; }); })
    .then(function() {
      refreshCartDrawer();
    })
    .catch(function(err) {
      console.error('[LP Cart]', err);
      if (isSoldOutError(err)) {
        openStoqModal(btn).then(function(opened) {
          if (!opened) openThemeRestockPopup(btn);
        });
        return;
      }
      showBtnError(btn, err.description || 'Erro — tente novamente');
    })
    .finally(function() {
      btn.classList.remove('lp-atc-btn--loading');
      btn.disabled = false;
    });
  }

  var stoqProductScriptPromise = null;

  function waitForStoqConfig() {
    if (window._RestockRocketConfig && window._RestockRocketConfig.scriptUrlProduct && window._RestockRocketConfig.settings) {
      return Promise.resolve(window._RestockRocketConfig);
    }

    return new Promise(function(resolve, reject) {
      var elapsed = 0;
      var interval = 50;
      var timeout = 3000;
      var timer = setInterval(function() {
        elapsed += interval;
        if (window._RestockRocketConfig && window._RestockRocketConfig.scriptUrlProduct && window._RestockRocketConfig.settings) {
          clearInterval(timer);
          resolve(window._RestockRocketConfig);
        } else if (elapsed >= timeout) {
          clearInterval(timer);
          reject(new Error('Stoq config unavailable'));
        }
      }, interval);
    });
  }

  function fetchRestockProductByVariant(variantId) {
    return waitForStoqConfig()
      .then(function(config) {
        var host = config.host || 'https://app.restockrocket.io';
        return fetch(host + '/api/v1/embed/product_variant_data.json?variant_id=' + encodeURIComponent(variantId), {
          headers: {
            'Accept': 'application/json',
            'X-Shopify-Shop-Domain': config.shop || (window.Shopify && window.Shopify.shop) || ''
          }
        });
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Stoq variant lookup failed');
        return response.json();
      })
      .then(function(data) {
        var product = data.product || {};
        return {
          title: product.title || data.title || '',
          variantTitle: data.title || ''
        };
      });
  }

  function getRestockProduct(btn) {
    var variantId = parseInt(btn.dataset.variantId, 10);
    var productId = parseInt(btn.dataset.productId, 10);

    return {
      id: isNaN(productId) ? null : productId,
      title: btn.dataset.productTitle || '',
      handle: btn.dataset.productHandle || '',
      available: false,
      variants: [{
        id: variantId,
        title: btn.dataset.variantTitle || '',
        available: false,
        public_title: btn.dataset.variantTitle || null
      }]
    };
  }

  function configureStoqProduct(btn) {
    window._RestockRocketConfig = window._RestockRocketConfig || {};
    window._RestockRocketConfig.product = getRestockProduct(btn);
    window._RestockRocketConfig.selected_variant_id = parseInt(btn.dataset.variantId, 10);
    window._RestockRocketConfig.selected_variant_available = false;
  }

  function loadStoqProductScript() {
    if (window._RestockRocket && window._RestockRocket.openModal) return Promise.resolve();
    if (stoqProductScriptPromise) return stoqProductScriptPromise;

    stoqProductScriptPromise = waitForStoqConfig()
      .then(function(config) {
        return new Promise(function(resolve, reject) {
          var script = document.createElement('script');
          script.src = config.scriptUrlProduct;
          script.async = true;
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      })
      .catch(function(err) {
        stoqProductScriptPromise = null;
        throw err;
      });

    return stoqProductScriptPromise;
  }

  function openStoqModal(btn) {
    configureStoqProduct(btn);

    return Promise.resolve()
      .then(function() {
        if (btn.dataset.productTitle || !btn.dataset.variantId) return;

        return fetchRestockProductByVariant(btn.dataset.variantId)
          .then(function(data) {
            btn.dataset.productTitle = data.title || '';
            btn.dataset.variantTitle = data.variantTitle || '';
            configureStoqProduct(btn);
          })
          .catch(function() {
            return null;
          });
      })
      .then(function() {
        if (window._RestockRocket && window._RestockRocket.openModal) {
          window._RestockRocket.openModal(window._RestockRocketConfig.product, window._RestockRocketConfig.selected_variant_id);
          return true;
        }

        return loadStoqProductScript()
          .then(function() {
            if (window._RestockRocket && window._RestockRocket.openModal) {
              window._RestockRocket.openModal(window._RestockRocketConfig.product, window._RestockRocketConfig.selected_variant_id);
              return true;
            }
            return false;
          });
      })
      .catch(function() {
        return false;
      });
  }

  function openThemeRestockPopup(btn) {
    var popup = document.querySelector('[data-notify-popup]');
    if (!popup) return false;

    var titleInput = popup.querySelector('.halo-notify-product-title');
    var linkInput = popup.querySelector('.halo-notify-product-link');
    var variantInput = popup.querySelector('.halo-notify-product-variant');

    if (titleInput) titleInput.value = btn.dataset.productTitle || '';
    if (linkInput) linkInput.value = btn.dataset.productUrl || window.location.href;
    if (variantInput) variantInput.value = btn.dataset.variantTitle || '';

    popup.querySelectorAll('.form-field').forEach(function(el) {
      el.classList.remove('hidden');
    });
    popup.querySelectorAll('.form-message').forEach(function(el) {
      el.classList.add('hidden');
    });
    document.body.classList.add('notify-me-show');
    return true;
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.lp-atc-btn');
    if (!btn) return;
    if (isRestockButton(btn)) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      openStoqModal(btn).then(function(opened) {
        if (!opened) openThemeRestockPopup(btn);
      });
      return;
    }
    e.preventDefault();
    lpAddToCart(btn.dataset.variantId, btn);
  }, true);
})();
